import { render, staticRenderFns } from "./UserProfileObjs.vue?vue&type=template&id=ebfb0940&scoped=true&"
import script from "./UserProfileObjs.vue?vue&type=script&lang=js&"
export * from "./UserProfileObjs.vue?vue&type=script&lang=js&"
import style0 from "./UserProfileObjs.vue?vue&type=style&index=0&id=ebfb0940&prod&lang=scss&scoped=true&"
import style1 from "./UserProfileObjs.vue?vue&type=style&index=1&id=ebfb0940&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebfb0940",
  null
  
)

export default component.exports